import { render, staticRenderFns } from "./InvoicesCommission.vue?vue&type=template&id=459811cc&scoped=true"
import script from "./InvoicesCommission.vue?vue&type=script&lang=js"
export * from "./InvoicesCommission.vue?vue&type=script&lang=js"
import style0 from "./InvoicesCommission.vue?vue&type=style&index=0&id=459811cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459811cc",
  null
  
)

export default component.exports